export default {
  height: 21,
  width: 18,
  svg: `
    <path d="M3 7c0 2.76143 2.23858 5 5 5h5.7322L9.61621 7.88379l1.76759-1.76758 6.25 6.24999c.4881.4881.4881 1.2795 0 1.7676l-6.25 6.25-1.76759-1.7676L13.7322 14.5H8C3.85786 14.5.5 11.1421.5 7V1.375c0-.34517.279819-.624998.625-.624998h1.25c.34518 0 .625.279828.625.624998V7z"/>
`
}
